import MinorDetails from './MinorDetails';

export default MinorDetails;
